import { render, staticRenderFns } from "./MiddlePanelCheckout.vue?vue&type=template&id=53842f20&scoped=true&lang=pug&"
import script from "./MiddlePanelCheckout.vue?vue&type=script&lang=js&"
export * from "./MiddlePanelCheckout.vue?vue&type=script&lang=js&"
import style0 from "./MiddlePanelCheckout.vue?vue&type=style&index=0&id=53842f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53842f20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VDivider,VIcon,VProgressLinear,VSkeletonLoader,VSpacer,VTab,VTabs})
